import { useMemo } from 'react';
import { Outlet, useParams } from 'react-router-dom';

import NotFoundPage from 'src/pages/main/404';

import i18nConfig from 'src/config/i18n.json';
import styles from './index.sass';

function MainLayout() {
	const params = useParams();

	const contents = useMemo(() => {
		if (params.lang && !i18nConfig.languageKeys.includes(params.lang)) {
			return <NotFoundPage />;
		}

		return <Outlet />;
	}, [params.lang]);

	return <main className={styles.mainLayout}>{contents}</main>;
}

export default MainLayout;
